import React from 'react';
import { Tooltip } from '@mantine/core';

function ChordComponent(props) {
  const tooltipMsg = "Sie haben einen externen Empfänger gewählt. Mieterbezogene Platzhalter sind in Nachrichten mit externen Empfängern nicht verfügbar.";

  function handleMouseDown(e) {
    // Prevent Draft.js from letting the user select or click the disabled placeholder
    e.preventDefault();
    e.stopPropagation();
  }

  return (
    <Tooltip 
      label={tooltipMsg} 
      wrapLines 
      width={300}
      style={{ zIndex: 1000 }} // Ensure it stays above DraftJS UI layers
    >
      {/* We add the 'rdw-mention-link' class back so it picks up your global CSS */}
      <span 
        className="rdw-mention-link" 
        onMouseDown={handleMouseDown}
        style={{
          opacity: 0.6,
          cursor: 'not-allowed',
          // display: 'inline-block',
          // // Fallback styles that mimic your standard placeholder "pill" look
          // backgroundColor: '#e6e6ff',
          // borderRadius: '3px',
          // padding: '0px 4px',
          textDecoration: 'none',
          color: 'inherit' // Ensures it uses the text color defined by your class
        }}
      >
        {props.children}
      </span>
    </Tooltip>
  );
}

export default ChordComponent;